<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Docentes FAZ</h1>
        </div>
      </v-img>
    </v-card>
    <!--CONTIENE LA INFORMACION QUE SE MUESTRA EN LA PÁGINA ACTUAL-->
    <div class="paContTitulo">
      <!--TITULO DE LA TABLA-->
      <span class="title">
        <h2> Profesor/a de Tiempo Completo (PTC)</h2>
      </span>
      <hr>
      <!--CONTENEDOR QUE CONTIENE LA TABLA DE LOS DOCENTES PTC-->
      <div class="gralEstiloTablas">
        <v-data-table dense :headers="headers" :items="itemPTC" item-key="name" class="elevation-1">
          <template v-slot:item.foto="{ item }">
            <div class="p-2">
              <v-img :src="require(`../../assets/img/pa/${item.foto}`)" :alt="item.nombre" height="50px"
                width="50px"></v-img>
            </div>
          </template>
          <template #item.nombre="{ item }">
            <a  :href="`/conocenos/planta-academica/profesores/${item.ruta}`">
              {{ item.nombre }}
            </a>
          </template>
        </v-data-table>
      </div>
      <hr />
      <!--CONTENEDOR QUE MUESTRA LOS NOMBRES DE LOS DOCENTES HSM-->
      <v-card class="mx-left mt-5">
        <v-card-title class="paMostrarItemsHSM" @click.stop="ocultarHSM = !ocultarHSM">
          Plaza por Hora-Semana-Mes (HSM)
          <v-spacer></v-spacer>
          <v-icon v-if="ocultarHSM == false">mdi-chevron-down</v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-card-title>
        <v-treeview v-show="ocultarHSM" return-object item-key="id" hoverable :items="itemHSM">
          <template v-slot:label="{ item }">
            <v-dialog transition="dialog-bottom-transition" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-icon width="75" height="75" class="mr-5 hidden-sm-and-down">mdi-account</v-icon>
                <a color="primary" v-bind="attrs" v-on="on">{{ item.nombre }}</a>
              </template>
              <template v-slot:default="dialog">
                <v-card class="paDialogTextHSM">
                  <v-toolbar dark>CONTACTO</v-toolbar>
                  <v-icon size="250">mdi-account</v-icon>
                  <h2>{{ item.nombre }}</h2>
                  <v-card-text>
                    <b>CATEGORIA: </b>{{ item.categoria }}
                    <br />
                    <b>AREA: </b>{{ item.area }}
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn text @click="dialog.value = false">CERRAR</v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </template>
        </v-treeview>
      </v-card>
    </div>
  </v-app>
</template>
<script>
import datos from '../../../personal.json';

export default {
  data: () => ({
    ocultarPTC: true,
    ocultarHSM: false,
    ocultarTEMP: false,
    selectionPTC: [],
    selectionHSM: [],
    itemPTC: [],
    itemHSM: [],
    itemTEMP: [],
    active: [],
    dialog: true,
    img: require('../../assets/img/logo_ujed.png'),
    imgTitle: require('../../assets/img/banner-docenteFaz.jpeg'),
    fields: ['foto', 'name', 'area', 'sni'],
    obtRuta: [
      {
        text: 'Inicio',
        disabled: false,
        ruta: '/',
      },
      {
        text: 'Conócenos',
        disabled: true,
        ruta: '/',
      },
      {
        text: 'Planta Académica',
        disabled: true,
        ruta: '/',
      },
    ],
    headers: [
      {
        text: 'Foto',
        align: 'start',
        sortable: false,
        value: 'foto',
      },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Área de Estudio', value: 'area' },
      { text: 'SNI', value: 'sni' },
    ],
  }),
  mounted() {
    this.itemsPTCA();
    this.itemsHSMA();
    this.itemsTEMPA();
  },
  methods: {
    itemsPTCA() {
      return datos.map((item) => {
        if (item.categoria === 'PTC') {
          this.itemPTC.push(item);
        }
        return this.itemPTC;
      });
    },
    itemsHSMA() {
      return datos.map((item) => {
        if (item.categoria === 'HSM') {
          this.itemHSM.push(item);
        }
        return this.itemHSM;
      });
    },
    itemsTEMPA() {
      return datos.map((item) => {
        if (item.categoria === 'TEMP') {
          this.itemTEMP.push(item);
        }
        return this.itemTEMP;
      });
    },
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
